import { ChangeDetectorRef, Component } from "@angular/core";
import { Router } from "@angular/router";
import { AuditTrailEmpDetails, Header } from "@aptsi-types";
import { AuditTrailAuthoringService } from "../audit-trail-auth.service";

@Component({
  selector: "app-transfer-audit-details",
  templateUrl: "./transfer-audit-details.component.html",
  styleUrls: ["./transfer-audit-details.component.scss"],
})
export class TransferAuditDetailsComponent {
  id: number;
  displayName: string;
  mail: string;
  organization: string;
  guid: string;
  startDate: string;
  organizationId: number;
  oldOrganization: string;
  neworganization: string;
  status: string;
  date_of_birth: string;
  status_change_date: string;
  status_change_reason: string;
  status_change_timestamp: string;
  organization_name: string;
  transfertimestamp: Date;

  totalPages = 0;
  totalPagesNormal = 0;
  totalPagesSearch = 0;

  itemsPerPage =7;
  currentPage = 1 ;


  get paginatedData() {
    
      if(!this.issearch){
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredData.slice(start, end);
      }
      else{
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        
        return this.searchedData.slice(start, end);
      }
      
    
  }

  changePage(page: number) {
    this.currentPage = page;
    if (!this.issearch) {
      this.totalPages = this.totalPagesNormal;  // Ensure correct total pages
      this.fetchempDetails();
    } else {
      this.totalPages = this.totalPagesSearch;  // Ensure correct total pages
      this.fetchempDetailsSearch();
    }
  }

  filteredData:  AuditTrailEmpDetails[] = []; 
  searchedData:  AuditTrailEmpDetails[] = []; 


  buttonConfig = {
     update: false,
     delete: false,
     import: false,
     configure: false
  };

  headers: Header[] = [
    {
      name: "Digital Id",
      property: "guid",
      showInDropdown: true,
      description: "Globally unique identifier for the digital record", // Tooltip content
    },
    {
      name: "Name",
      property: "displayName",
      showInDropdown: true,
      description: "Full name of the individual",
    },
    {
      name: "Previous Organization",
      property: "oldOrganization",
      showInDropdown: true,
      description: "Organization the individual was previously associated with",
    },
    {
      name: "Current Organization",
      property: "neworganization",
      showInDropdown: true,
      description: "Organization the individual is currently associated with",
    },
    {
      name: "Email",
      property: "mail",
      showInDropdown: true,
      description: "Email address of the individual",
    },
    {
      name: "Transfer Timestamp",
      property: "transfertimestamp",
      showInDropdown: false,
      description: "Exact timestamp of the transfer between organizations",
    },
  ];
  
  searchText: string = null;
  filterByHeader: string = "all";
  filterName: string = null;
  transferedEmpDetails: AuditTrailEmpDetails[] = [];
  nullver: number = 1;
  issearch: boolean = false;

  constructor(
    private router: Router,
    private auditTrailAuthoringService: AuditTrailAuthoringService,
    private cdr: ChangeDetectorRef
  ) {}

  async ngOnInit(): Promise<void> {
    // const dropdownHeaders = this.headers.filter(
    //   header => header.showInDropdown
    // );

    // if (dropdownHeaders.length > 1) {
    //   this.filterByHeader = dropdownHeaders[1].property;
    // }

    this.fetchempDetails();
    this.cdr.detectChanges(); 
  }

  async fetchempDetails() {
    try {
      const response = await this.auditTrailAuthoringService
        .getTransferedEmpDetailView(this.currentPage - 1)
        .toPromise();
        this.filteredData = [...response];
  
        if (response.length > 0 && response[0].totalPages) {
          this.totalPagesNormal = response[0].totalPages;
          this.totalPages = this.totalPagesNormal;  // Sync `totalPages` with `totalPagesNormal`
          this.currentPage = response[0].currentPage + 1;
        }
      // this.transferedEmpDetails =
      //   response["Resource fetched successfully."] || [];
      // this.transferedEmpDetails.sort((a, b) => a.id - b.id);
    } catch (error) {
      console.error("Error fetching assets :", error);
    }
  }
  
  async fetchempDetailsSearch() {
    try {
      
      const response = await this.auditTrailAuthoringService
        .getTransferedEmpDetailViewSearch(this.currentPage - 1, this.searchText, this.filterByHeader)
        .toPromise();
      this.searchedData = [...response];
  
      if (response.length > 0 && response[0].totalPages) {
        this.totalPagesSearch = response[0].totalPages;
        this.totalPages = this.totalPagesSearch;  // Sync `totalPages` with `totalPagesSearch`
        this.currentPage = response[0].currentPage + 1;
      }
    } catch (error) {
      console.error("Error fetching assets:", error);
    }
  }
 

   async searchempDetails(): Promise<void> {
    try {
      if (this.searchText) {

        // Default value
        if (!this.filterByHeader) {
          this.filterByHeader = "all";
        }

        this.issearch = true;

        await this.fetchempDetailsSearch();
        this.totalPages = this.totalPagesSearch;

        const selectedHeader = this.headers.find(
          (h) => h.property === this.filterByHeader && h.showInDropdown
        );

        if (this.filterByHeader === "all") {

          this.searchedData = this.searchedData.filter((rule) =>
            this.headers.some((header) => {
              const value = rule[header.property];

              return value
                ?.toString()
                .toLowerCase()
                .includes(this.searchText.toLowerCase());
            })
          );

        } else if (selectedHeader) {

          this.searchedData = this.searchedData.filter((rule) => {
            const value = rule[selectedHeader.property];

            return value
              ?.toString()
              .toLowerCase()
              .includes(this.searchText.toLowerCase());
          });

          this.searchedData.sort((a, b) =>
            a[selectedHeader.property]
              ?.toString()
              .localeCompare(b[selectedHeader.property]?.toString())
          );

        } else {
          this.filteredData = [];
        }

      } else {

        this.issearch = false;
        await this.fetchempDetails();

      }
    } catch (error) {
      console.error("Error during search:", error);
    }
  }

  back() {
    try {
      if (this.issearch) {
        this.issearch = false;
        this.totalPages = this.totalPagesNormal;  // Restore total pages for normal pagination
        this.currentPage = 1;
        this.fetchempDetails(); 
      } else {
        this.router.navigate(['digital-identity/auth-tools/audit-trail-auth']);
      }
     } catch (error) {
        console.error("Error fetching Assets:", error);
     }
    }

}
